<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.ActiveLicense" | translate }}
    </li>
    <!--   <li style="position: absolute; right: 39px">
      <div class="d-flex flex-row-reverse">
        <div>
          <a
            [routerLink]="['/payment-plan']"
            style="
              float: right;
              margin-bottom: 10px;
              margin-left: 10px;
              width: 168px;
              justify-content: center;
            "
            placement="bottom"
            ngbTooltip="{{ 'Form.Renewlicense' | translate }}"
            class="btn-shadow d-inline-flex align-items-center btn btn-success"
            routerLinkActive="router-link-active"
            >{{ "Form.Renewlicense" | translate }}
          </a>
        </div>
         <div *ngIf="showLicenseManage">
          <a
            [routerLink]="['/page/add-renew-license']"
            class="btn-shadow d-inline-flex align-items-center btn btn-primary"
            style="
              float: right;
              margin-bottom: 10px;
              margin-left: 10px;
              width: 168px;
              justify-content: center;
            "
            placement="bottom"
            ngbTooltip="{{ 'Form.AddEditPlan' | translate }}"
          >
            {{ "Form.ADDPlan" | translate }}
          </a>
        </div>
      </div>
    </li> -->
  </ol>
</nav>

<div class="row">
  <div class="col-md-12">
    <div style="margin-bottom: 0 !important">
      <table>
        <thead class="_tas-custom-row">
          <tr>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.transactionId"
                placeholder="Filter by Transaction Id"
                class="form-control m-1 mb-1 me-1 ms-0"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 9%">
              <input
                type="text"
                [(ngModel)]="filter.companyName"
                placeholder="Filter by Company Name"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.moduleName"
                placeholder="Filter by Module Name"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.moduleDisplayName"
                placeholder="Filter by Module Display Name"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.purchaseDate"
                placeholder="Filter by Purchase Date"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.validFrom"
                placeholder="Filter by Valid From"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.validUpto"
                placeholder="Filter by Valid Upto"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
      </table>
    </div>

    <div *ngIf="isLoading; else notLoading" class="loaderdata">
      <div class="spinner-border" role="status">
        <span class="sr-only">{{ "Form.Loading" | translate }}</span>
      </div>
    </div>
    <ng-template #notLoading>
      <div class="main-card mb-3 card">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead class="font-size-lg text-white">
            <tr>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  Transaction Id
                  <i
                    (click)="changeSort('transactionId')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.Placeholder.PROJECT_NAME" | translate }}
                  <i
                    (click)="changeSort('projectName')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.moduleName" | translate }}
                  <i
                    (click)="changeSort('moduleName')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.moduleDisplayName" | translate }}
                  <i
                    (click)="changeSort('moduleDisplayName')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.purchaseDate" | translate }}
                  <i
                    (click)="changeSort('purchaseDate')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.validFrom" | translate }}
                  <i
                    (click)="changeSort('validFrom')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.validUpto" | translate }}
                  <i
                    (click)="changeSort('validUpto')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.Placeholder.TransactionDetails" | translate }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="data.length; else noData">
            <tr *ngFor="let item of data">
              <td>{{ item.transactionId }}</td>
              <td>{{ item.companyName }}</td>
              <td>{{ item.moduleName }}</td>
              <td>{{ item.moduleDisplayName }}</td>
              <td>{{ item.purchaseDate | date : "dd MMM yyyy" }}</td>
              <td>{{ item.validFrom | date : "dd MMM yyyy" }}</td>
              <td>
                {{ item.validUpto | date : "dd MMM yyyy" }}
                <p style="color: grey">
                  ({{ item.validUpto | remainingDays }})
                </p>
              </td>
              <td>
                <div *ngIf="item.transactionId; else noTransactionId">
                  <a
                    style="color: blue"
                    routerLink="/page/transaction-detail/{{
                      item.transactionId
                    }}"
                    >{{ "Form.Placeholder.Viewtransactiondetails" | translate }}
                  </a>
                </div>
                <ng-template #noTransactionId>-</ng-template>
              </td>
            </tr>
          </tbody>
          <ng-template #noData>
            <tbody>
              <tr>
                <td colspan="7" class="text-center">
                  {{ "Form.NoDataAvailable" | translate }}
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </ng-template>
  </div>
</div>
